var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Radar chart preview",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 200)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-90 78,-28 48,73 -48,73 -78,-28",
    fill: "#E3F2FD",
    stroke: "#90CAF9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-60 52,-19 32,49 -32,49 -52,-19",
    fill: "#BBDEFB",
    stroke: "#64B5F6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-32 28,-10 18,26 -18,26 -28,-10",
    fill: "#90CAF9",
    stroke: "#42A5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -90,
    x2: 0,
    y2: 90,
    stroke: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: -28,
    x2: -78,
    y2: 28,
    stroke: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 73,
    x2: -48,
    y2: -73,
    stroke: "#B0BEC5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarChart);
export default __webpack_public_path__ + "static/media/radar-chart.4ce327d87acab8cee6021474ac93fde7.svg";
export { ForwardRef as ReactComponent };